import * as z from 'zod';
import { isoDateToAppDate, timeStringToDayJs } from '../base-codecs';
export const ReservableProductAvailability = z.object({
    bookable_window: z.object({
        start: timeStringToDayJs,
        end: timeStringToDayJs
    }).nullable(),
    max_advance_booking_minutes: z.int().nonnegative().nullish(),
    min_advance_booking_minutes: z.int().nonnegative().nullish(),
    bookable_from: isoDateToAppDate.nullish(),
    bookable_until: isoDateToAppDate.nullish(),
    bookable_weekdays: z.array(z.int().min(1).max(7)).max(7).nullish()
});
